import * as React from "react";

type ValidElements = 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'div';

interface ParagraphProps {
    text: string;
    type?: string;
    as?: ValidElements;
}

export const Paragraph: React.FC<ParagraphProps> = ({ text, type, as = 'p' }) => {
    const Tag = as;
    
    return (
        <>
            {text && React.createElement(Tag, {
                className: type,
                dangerouslySetInnerHTML: { __html: text.replace(/\n/g, '<br />') }
            })}
        </>
    );
};

export default Paragraph;